<template>
  <router-link v-bind="[$props, $attrs]" @click.native="handleLinkClick" to="#"
    >{{ label }} <v-icon v-if="icon">{{ icon }}</v-icon></router-link
  >
</template>

<script>
export default {
  name: 'BookAppointmentLink',
  props: {
    label: {
      type: String,
      required: false,
      default: 'Book Appointment'
    },
    icon: {
      type: String,
      required: false,
      default: null
    },
    to: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleLinkClick() {
      if (this.$warehouseId && this.$warehouseOrgId) {
        this.mixpanel.track(this.mixpanel.events.ACTION.BOOK_APPOINTMENT_CLICKED, {
          'Warehouse ID': this.$warehouseId,
          'Org ID': this.$warehouseOrgId
        });
      }
      this.$router.push(this.to);
    }
  }
};
</script>
